import { createSelector } from 'reselect';
import { getActivityModel, getTempValidationErrors } from '../../activity.selectors';
import * as itemsPopulationConstants from './itemsPopulation.constants';

export const getTempItemsPopulation = createSelector(getActivityModel, (activity) => activity.get(itemsPopulationConstants.TEMP_ITEMS_POPULATION));
export const getTempItemsPopulationValidationErrors = (state, isMemberFilter) => {
  const validationErrors = getTempValidationErrors(state, isMemberFilter);
  return validationErrors && validationErrors.get(itemsPopulationConstants.TEMP_ITEMS_POPULATION);
};
